<script>
  import FormModal from './FormModal.svelte';

  export let session;
</script>

{#if session}
  <FormModal {session} on:close={() => session = null} />
{/if}